export const tmzOptions = Array.from({ length: 15 }, (_, i) => ({
  value: `GMT+${i < 10 ? `0${i}` : i}:00`,
  label: `GMT+${i < 10 ? `0${i}` : i}:00`,
}))

export const tmzParse = (tmz) => {
  if (!tmz) return tmz
  return tmz.replace(/GMT([+-])(\d+):00/, (match, sign, hours) => {
    const num = parseInt(hours, 10)
    return `GMT${sign}${num < 10 ? `0${num}` : num}:00`
  })
}
